<template>
  <div class="feature-unavailable-container">
    <div class="feature-icon">
      <slot name="icon">
        <mdb-icon :icon="icon" class="feature-main-icon" />
      </slot>
    </div>
    <h3 class="feature-title">{{ title }}</h3>
    <p class="feature-description">{{ description }}</p>
    <p class="feature-contact">{{ contactMessage }}</p>
    <div class="feature-contact-info">
      <a :href="whatsappLink" target="_blank" rel="noopener noreferrer" class="contact-item">
        <mdb-icon fab icon="whatsapp" class="contact-icon whatsapp-icon" />
        <span>{{ phone }}</span>
      </a>
      <a :href="mailtoLink" class="contact-item">
        <mdb-icon icon="envelope" class="contact-icon" />
        <span>{{ email }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mdbIcon } from "mdbvue";

export default {
  name: 'FeatureUnavailable',
  components: {
    mdbIcon
  },
  props: {
    icon: {
      type: String,
      default: 'user-shield'
    },
    title: {
      type: String,
      default: '¡Nueva Funcionalidad Exclusiva de MyFRAC!'
    },
    description: {
      type: String,
      default: 'Esta característica está disponible para implementación bajo demanda en su fraccionamiento.'
    },
    contactMessage: {
      type: String,
      default: 'Si está interesado en integrarla y mejorar su seguridad, comuníquese con nuestro equipo comercial.'
    },
    phone: {
      type: String,
      default: '+52 443 630 5436'
    },
    email: {
      type: String,
      default: 'contacto@kiritek.com'
    }
  },
  computed: {
    whatsappLink() {
      const phoneNumber = this.phone.replace(/[^0-9]/g, '')
      return `https://wa.me/${phoneNumber}`
    },
    mailtoLink() {
      return `mailto:${this.email}`
    }
  }
}
</script>

<style scoped>
.feature-unavailable-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
  min-height: 400px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
}

.feature-icon {
  margin-bottom: 30px;
}

.feature-main-icon {
  font-size: 80px;
  color: #67a3cf;
  animation: pulse-icon 2s ease-in-out infinite;
}

@keyframes pulse-icon {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.feature-title {
  font-family: OpenSans-Bold;
  font-size: 26px;
  color: #026ab4;
  margin-bottom: 20px;
  line-height: 1.4;
}

.feature-description {
  font-family: OpenSans-Semibold;
  font-size: 16px;
  color: #5d6078;
  margin-bottom: 15px;
  max-width: 600px;
  line-height: 1.6;
}

.feature-contact {
  font-family: OpenSans-Regular;
  font-size: 14px;
  color: #5d6078;
  margin-bottom: 30px;
  max-width: 650px;
  line-height: 1.6;
}

.feature-contact-info {
  display: flex;
  gap: 40px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}

a.contact-item {
  text-decoration: none;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.contact-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.contact-icon {
  font-size: 20px;
  color: #67a3cf;
}

.whatsapp-icon {
  color: #25D366;
}

.contact-item span {
  font-family: OpenSans-Semibold;
  font-size: 13px;
  color: #5d6078;
}
</style>
